/* CrickWillow bat builder */
(function(){
  function init(root){
    if(!root||root.__cwb) return; root.__cwb=true;
    var $=function(s,c){return (c||root).querySelector(s)};
    var $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s))};
    var rootUrl=root.dataset.rootUrl||'/', cur=root.dataset.currency||'GBP', nf=null;
    try{ nf=new Intl.NumberFormat(undefined,{style:'currency',currency:cur}); }catch(e){}
    function money(c){ return nf?nf.format(c/100):(c/100).toFixed(2)+' '+cur; }
    var REQ=[['willow','Willow'],['size','Size'],['weight','Weight'],['blade','Blade profile'],['shape','Blade shape'],['handle','Handle shape'],['grip','Grip colour'],['sticker','Stickers']];
    var qty=$('[data-cwb-qty]'), msg=$('[data-cwb-msg]'), totalEl=$('[data-cwb-total]'), listEl=$('[data-cwb-list]');
    var addBtn=$('[data-cwb-add]'), buyBtn=$('[data-cwb-buy]'), notes=$('[data-cwb-notes]'), wa=$('[data-cwb-wa]');
    var gripEl=$('[data-cwb-grip]'), stickerEl=$('[data-cwb-sticker]'), shapesEl=$('[data-cwb-shapes]');
    if(!qty||!msg||!totalEl||!listEl) return;
    function checked(n){ return $('input[name='+n+']:checked'); }
    function qn(){ return Math.max(1,parseInt(qty.value,10)||1); }
    function setMsg(t,ok){ msg.textContent=t; msg.style.color=ok?'var(--cw-green,#118c20)':'var(--cw-sale,#c62828)'; }

    function update(){
      var n=qn(), w=checked('willow'), rows=[], total=0, parts=[];
      REQ.forEach(function(r){
        var c=checked(r[0]); if(!c) return;
        var v=(r[0]==='willow')?c.dataset.label:c.value;
        rows.push([r[1], v+(r[0]==='willow'?' ('+money(+c.dataset.cents)+')':'')]);
        parts.push(r[1]+': '+v);
      });
      if(w) total+=(+w.dataset.cents)*n;
      $$('[data-cwb-extra]').forEach(function(c){
        if(!c.checked) return;
        total+=(+c.dataset.cents)*n;
        rows.push(['Extra', c.dataset.label+' (+'+money(+c.dataset.cents)+')']);
        parts.push('Extra: '+c.dataset.label);
      });
      listEl.textContent='';
      if(!rows.length){ var e0=document.createElement('li'); e0.className='cwb-empty'; e0.textContent='Choose your options to see your bat here.'; listEl.appendChild(e0); }
      rows.forEach(function(r){
        var li=document.createElement('li'), a=document.createElement('span'), b=document.createElement('strong');
        a.textContent=r[0]; b.textContent=r[1]; li.appendChild(a); li.appendChild(b); listEl.appendChild(li);
      });
      totalEl.textContent=w?money(total):'-';
      var g=checked('grip'); if(gripEl&&g) gripEl.setAttribute('fill',g.dataset.hex);
      var st=checked('sticker'); if(stickerEl) stickerEl.setAttribute('opacity',(st&&st.dataset.on==='1')?'1':'0');
      var sh=checked('shape'); if(shapesEl) shapesEl.setAttribute('data-sel',sh?sh.value:'');
      if(wa){ var t='Hi CrickWillow, I would like help with a custom bat.'+(parts.length?' '+parts.join(', ')+'.':''); wa.href=wa.dataset.waBase+'?text='+encodeURIComponent(t); }
    }

    root.addEventListener('change',function(e){
      var t=e.target;
      if(t.matches&&t.matches('[data-cwb-extra]')){
        var box=t.closest('.cwb-extra'), tx=box?box.querySelector('[data-cwb-extra-text]'):null;
        if(tx){ tx.hidden=!t.checked; if(t.checked) tx.focus(); }
      }
      update();
    });
    qty.addEventListener('input',update);
    $('[data-cwb-minus]').addEventListener('click',function(){ qty.value=Math.max(1,qn()-1); update(); });
    $('[data-cwb-plus]').addEventListener('click',function(){ qty.value=qn()+1; update(); });

    async function add(go){
      setMsg('',true);
      var miss=REQ.filter(function(r){return !checked(r[0])});
      if(miss.length){
        setMsg('Please choose: '+miss.map(function(r){return r[1]}).join(', ')+'.',false);
        var fs=$('[data-cwb-step='+miss[0][0]+']'); if(fs&&fs.scrollIntoView) fs.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      var n=qn(), w=checked('willow');
      var props={'Size':checked('size').value,'Weight':checked('weight').value,'Blade profile':checked('blade').value,'Blade shape':checked('shape').value,'Handle shape':checked('handle').value,'Grip colour':checked('grip').value,'Stickers':checked('sticker').value};
      var note=notes?notes.value.trim():''; if(note) props['Notes']=note;
      var items=[{id:+w.dataset.id,quantity:n,properties:props}], bad=false;
      $$('[data-cwb-extra]').forEach(function(c){
        if(!c.checked) return;
        var box=c.closest('.cwb-extra'), tx=box?box.querySelector('[data-cwb-extra-text]'):null, it={id:+c.dataset.id,quantity:n};
        if(tx){ var v=tx.value.trim(); if(!v){ bad=true; tx.focus(); return; } it.properties={'Name to engrave':v}; }
        items.push(it);
      });
      if(bad){ setMsg('Please type the name to engrave.',false); return; }
      addBtn.disabled=true; buyBtn.disabled=true;
      try{
        var res=await fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        var data=await res.json();
        if(!res.ok){ setMsg(data.description||data.message||'Could not add to cart.',false); addBtn.disabled=false; buyBtn.disabled=false; return; }
        if(go){ window.location.href=rootUrl+'checkout'; return; }
        var cart=await (await fetch(rootUrl+'cart.js')).json();
        document.querySelectorAll('[data-cw-cart-count]').forEach(function(x){x.textContent=cart.item_count});
        setMsg('Added to your cart.',true);
      }catch(err){ window.location.href=rootUrl+'cart'; return; }
      addBtn.disabled=false; buyBtn.disabled=false;
    }
    addBtn.addEventListener('click',function(){add(false)});
    buyBtn.addEventListener('click',function(){add(true)});
    update();
  }
  function initAll(){ document.querySelectorAll('[data-cwb]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
